import React, { useEffect } from "react";
import headerlogo from "../../../Assets/About/Banner.png";
import AOS from "aos";
import "aos/dist/aos.css";

const Banner = ({ title }) => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: false,
      offset: 100, // Trigger when the element is 100px from the viewport
      delay: 200,
    });
    return () => AOS.refresh();
  }, []);

  return (
    <div
      className="lg:h-[300px] md:h-[200px] h-[100px] lg:mt-[107px] md:mt-[73px] mt-[70px] bg-cover bg-center flex flex-col justify-center items-center text-white"
      style={{
        backgroundImage: `url(${headerlogo})`,
      }}
      data-aos="zoom-out"
    >
      <div data-aos="zoom-out" className="text-center">
        <h1 className="text-xl lg:text-3xl font-semibold lg:mb-20 mb-0 font-sans tracking-wide">
          {title}
        </h1>
      </div>
    </div>
  );
};

export default Banner;
